import vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import Vue from 'vue'

vue.component(CollapseTransition.name, CollapseTransition)
import {
    Button,
    Menu,
    MenuItem,
    Submenu,
    Input,
    Row,
    Col,
    Carousel,
    CarouselItem,
    Image,
    Tabs,
    TabPane,
    Dialog,
    Form,
    FormItem,
    Message,
    Container,
    Header,
    Aside,
    Main,
    MenuItemGroup,
    Badge,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Avatar,
    Card,
    Breadcrumb,
    BreadcrumbItem,
    Checkbox,
    Select,
    Option,
    Table,
    TableColumn,
    Pagination,
    Switch,
    Tooltip,
    Upload,
    MessageBox,
    Tree,
    Footer,
    InputNumber,
    CheckboxGroup,
    Cascader,
    DatePicker,
    Divider,
    RadioGroup,
    Radio,
    Loading,
    Progress,
    Tag,
    Popover,
    PageHeader
} from 'element-ui'

vue.use(Button)
vue.use(Menu)
vue.use(MenuItem)
vue.use(Input)
vue.use(Submenu)
vue.use(Row)
vue.use(Col)
vue.use(Carousel)
vue.use(CarouselItem)
vue.use(Image)
vue.use(Tabs)
vue.use(TabPane)
vue.use(Dialog)
vue.use(Form)
vue.use(FormItem)
vue.use(Container)
vue.use(Header)
vue.use(Aside)
vue.use(Main)
vue.use(MenuItemGroup)
vue.use(Badge)
vue.use(Dropdown)
vue.use(DropdownItem)
vue.use(DropdownMenu)
vue.use(Avatar)
vue.use(Card)
vue.use(Breadcrumb)
vue.use(BreadcrumbItem)
vue.use(Checkbox)
vue.use(Select)
vue.use(Option)
vue.use(Table)
vue.use(TableColumn)
vue.use(Pagination)
vue.use(Switch)
vue.use(Tooltip)
vue.use(Upload)
vue.use(Tree)
vue.use(Footer)
vue.use(InputNumber)
vue.use(CheckboxGroup)
vue.use(Cascader)
vue.use(DatePicker)
vue.use(Divider)
vue.use(RadioGroup)
vue.use(Radio)
vue.use(Loading)
vue.use(Progress)
vue.use(Tag)
vue.use(Popover)
vue.use(PageHeader)
vue.prototype.$confirm = MessageBox.confirm
vue.prototype.$message = Message


// WEBPACK FOOTER //
// ./src/element/index.js